import { Component, OnInit, HostListener, Output, Input, OnChanges, SimpleChanges, EventEmitter } from '@angular/core';
import { ConnectRestService } from '../services/connect-rest.service';

declare var $: any;

@Component({
  selector: 'app-signature-drop-box',
  templateUrl: './signature-drop-box.component.html',
  styleUrls: ['./signature-drop-box.component.scss']
})
export class SignatureDropBoxComponent implements OnInit {
  @Output() signatureSave = new EventEmitter();
  @Input() CurrentSignature; @Input() textContent;
  showInvalidFormatError: boolean = false;
  showDropBox: boolean = true;

  constructor(private connect: ConnectRestService) { }

  ngOnInit() {
  }
  @HostListener('drop', ['$event']) 
    ondrop(e) {
      e.preventDefault();
      e.stopPropagation();

      const images = e.dataTransfer.files;
      this.checkFile(images);
    } 

  checkFile(images) {
    const _this = this;
    this.connect.showLoader()
      if (images[0]) {
      var file = images[0];
      var fileName = file.name;
      var ext = fileName.split(".").pop();
      var filesize = file.size;//check filesize
      var maxsize = 5000000;//5mb maxsize

      if (((ext.toLowerCase() == "jpg") || (ext.toLowerCase() == "jpeg"))) {
        $.canvasResize(file, {
          width: 500,
          height: 0,
          crop: false,
          quality: 100,
          callback: function (data) {
            if (((ext.toLowerCase() == "jpg") || (ext.toLowerCase() == "jpeg"))) {
              var f = $.canvasResize('dataURLtoBlob', data);
              _this.showInvalidFormatError = false;
              _this.connect.hideLoader();
              _this.signatureSave.emit(data);
            } else {
              _this.showInvalidFormatError = true;
            }
            _this.connect.hideLoader();
          }
        });
      } else {
        this.showInvalidFormatError = true;
        this.connect.hideLoader();
      }
    } else{
      this.connect.hideLoader();
    }
  }

  rotateImage() {
    let img = new Image();
    img.src = this.CurrentSignature;

    let canvas = document.createElement("canvas");

    let ctx = canvas.getContext("2d");

    canvas.width = img.height;
    canvas.height = img.width;
    ctx.translate(canvas.width, canvas.height / canvas.width);
    ctx.rotate(Math.PI / 2);
    ctx.drawImage(img,0,0);
    this.signatureSave.emit(canvas.toDataURL('img/jpg'));
  }

  ngOnChanges(changes: SimpleChanges) {
    if(this.CurrentSignature) {
      this.showDropBox= false;
    } else {
      this.showDropBox = true;
    }
  }

  clearSignature() {
    this.signatureSave.emit(undefined)
  }
}
